import { FragmentDefiner, useReadFragment } from "../../../../GlobalHooks/useReadFragment";

export const FRAGMENT_PROPERTY_COVER_TAG = new FragmentDefiner(
	"Property",
	`
    image_count
    youtube
    files {
        id
    }
		latitude
		project {
			tour3d
		}
`
);

interface usePropertyCoverTagResponse {
	has_video: boolean;
	has_map: boolean;
	has_floorPlans: boolean;
	has_tour3d: boolean;
}

export const usePropertyCoverTag = ({
	files,
	youtube,
	latitude,
	tour3d,
}): usePropertyCoverTagResponse => {
	return {
		has_video: !!youtube,
		has_map: latitude && latitude != 0 ? true : false,
		has_floorPlans: files?.length > 0,
		has_tour3d: tour3d,
	};
};
